// The six framing factors (F1–F6), matching agent/schemas/question_generation.input.json.

import type {
  DataLocation,
  FocusArea,
  Frequency,
  Impact,
  PeopleInvolved,
  Sensitivity,
  TeamSize,
} from './types.js';

export const IMPACT_OPTIONS: Impact[] = [
  'Wasted staff hours',
  'Errors & rework',
  'Slow internal/external response time',
  'Compliance/audit risk',
  'Opportunity cost/bottleneck',
  'Staff frustration & churn',
];

export const FREQUENCY_OPTIONS: Frequency[] = [
  'Constantly / all day',
  'Daily',
  'Weekly',
  'Monthly',
  'Ad hoc',
];

export const PEOPLE_OPTIONS: PeopleInvolved[] = ['Just me', '2-5', '6-20', '20+'];

export const DATA_LOCATION_OPTIONS: DataLocation[] = [
  'M365 / SharePoint / email',
  'Databases / Fabric / Azure',
  'Documents & PDFs',
  'Third-party SaaS',
  'Paper / scans',
  'Not sure',
];

export const SENSITIVITY_OPTIONS: Sensitivity[] = [
  'No sensitive data',
  'Internal only',
  'Personal information',
  'Health or government data',
];

// ── Discover mode (D1–D7), matching discover.question_generation.input.json ──

export const FOCUS_AREA_OPTIONS: FocusArea[] = [
  'Admin & back-office',
  'Customer / client service',
  'Finance & accounts',
  'HR & recruitment',
  'Operations & delivery',
  'Sales & marketing',
  'Procurement & supply chain',
  'Compliance & reporting',
  'Frontline / clinical service',
  'IT & data',
];

export const TEAM_SIZE_OPTIONS: TeamSize[] = [
  'Just me',
  '2-10',
  '11-50',
  '51-200',
  '201-1000',
  '1001-5000',
  '5000+',
];
